import queryString from "query-string";
// Helper so I can use html`...` syntax, with lit-html extension
// on vscode that gives me autocomplete
const html = String.raw;

function renderTippyHTML(inlineAnchorTag: HTMLAnchorElement) {
  inlineAnchorTag.style.cursor = "default";
  const tooltipId = inlineAnchorTag.getAttribute("data-tooltip-id");
  const url = inlineAnchorTag.getAttribute("href");
  const text = inlineAnchorTag.innerText;
  const sanitizedUrl = queryString.exclude(url, ["__position__"]).trim();
  let decodedURL = "";

  try {
    decodedURL = decodeURIComponent(sanitizedUrl);
  } catch {
    decodedURL = sanitizedUrl;
  }

  return html`<div class="tippy-berserker-container-wrapper">
    <div class="tippy-berserker-container-root">
      <span
        onclick='window.open("${sanitizedUrl}","_blank")'
        class="tippy-berserker-url tooltipAction"
        >${decodedURL}</span
      >
      <div class="tippy-berserker-separator"></div>
      <span
        class="tooltipAction"
        onclick='window.berserkerTippyClickUpdate("${tooltipId}","${sanitizedUrl}","${text.replace(
          /["']/g,
          ""
        )}")'
        >Update</span
      >
      <div class="tippy-berserker-separator"></div>
      <span
        class="tooltipAction"
        onclick='window.berserkerTippyClickUnlink("${tooltipId}","${sanitizedUrl}","${text.replace(
          /["']/g,
          ""
        )}")'
        >Unlink</span
      >
    </div>
  </div>`;
}

export const TippyPureHTML = {
  renderTippyHTML,
};
